<template>
  <div class="terms-container">
    <div class="terms-wrapper">
      <!-- Header Section -->
      <div class="terms-header">
        <h1 class="terms-title">Termos de Uso</h1>
        <p class="terms-subtitle">
          Leia e aceite os termos para continuar utilizando o sistema
        </p>
      </div>

      <!-- Content Card -->
      <div class="terms-card">
        <div class="terms-content">
          <!-- Icon and intro -->
          <div class="content-header">
            <div class="content-icon">
              <i class="fas fa-info-circle"></i>
            </div>
            <h2 class="content-title">Informações Importantes</h2>
          </div>

          <!-- Terms text -->
          <div class="terms-text">
            <div class="text-item">
              <div class="item-bullet"></div>
              <p>
                Os Termos de Uso determinam os termos e condições aplicáveis ao
                uso do sistema.
              </p>
            </div>

            <div class="text-item">
              <div class="item-bullet"></div>
              <p>
                Para acessar e utilizar o sistema, todos os usuários devem
                aceitar os termos e condições contidos nos Termos de Uso.
              </p>
            </div>

            <div class="text-item">
              <div class="item-bullet"></div>
              <p>
                Por favor, revise os termos cuidadosamente antes de utilizar o
                sistema.
              </p>
            </div>

            <div class="text-item">
              <div class="item-bullet"></div>
              <p>
                Caso você não concorde com os termos e condições, não será
                possível utilizar o sistema.
              </p>
            </div>

            <div class="text-item">
              <div class="item-bullet"></div>
              <p>
                O Sistema Clin reserva-se o direito de atualizar os Termos de
                Uso, ao exclusivo critério do Sistema Clin. Você deve revisar os
                Termos de Uso periodicamente para eventuais atualizações e
                modificações.
              </p>
            </div>
          </div>

          <!-- Action buttons -->
          <div class="action-buttons">
            <a
              class="action-btn primary-btn"
              href="https://sistemaclin.com.br/termos-de-uso/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fas fa-external-link-alt"></i>
              <span>Ler Termos de Uso</span>
            </a>

            <a
              class="action-btn secondary-btn"
              href="https://sistemaclin.com.br/politicas-de-privacidade/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="fas fa-shield-alt"></i>
              <span>Política de Privacidade</span>
            </a>
          </div>

          <!-- Agreement section -->
          <div class="agreement-section">
            <div class="agreement-card">
              <div class="checkbox-wrapper">
                <b-form-checkbox
                  v-model="accept"
                  name="check-button"
                  class="custom-checkbox"
                >
                  <span class="checkbox-label">
                    Eu li e aceito os
                    <a
                      href="https://sistemaclin.com.br/termos-de-uso/"
                      target="_blank"
                      class="terms-link"
                    >
                      Termos de Uso
                    </a>
                    e a
                    <a
                      href="https://sistemaclin.com.br/politicas-de-privacidade/"
                      target="_blank"
                      class="terms-link"
                    >
                      Política de Privacidade
                    </a>
                  </span>
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <!-- Error messages -->
          <div v-if="errors.length > 0" class="error-section">
            <ErrorsMessages :errors="errors" />
          </div>

          <!-- Save button -->
          <div class="save-section">
            <v-btn
              class="save-btn"
              :class="{ 'btn-disabled': !accept }"
              :disabled="loading || !accept"
              :loading="loading"
              @click="save"
              large
            >
              <i class="fas fa-check save-icon"></i>
              {{ loading ? "Salvando..." : "Aceitar e Continuar" }}
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="terms-footer">
        <div class="footer-info">
          <i class="fas fa-lock"></i>
          <span>Suas informações estão seguras conosco</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import api from "../../services/api";
import { userData } from "../../lib/functions";

export default {
  name: "Terms",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      accept: false,
      loading: false,
      errors: [],
    };
  },
  methods: {
    async save() {
      try {
        this.loading = true;
        let { accept } = this;

        if (!accept) {
          this.loading = false;
          this.errors = ["Aceite os termos"];
          return;
        }

        const response = await api.post("/rest-home/user/terms");
        const { error, errors } = response.data;

        if (error) {
          this.loading = false;
          this.errors = errors;
        } else {
          let { user } = userData();
          user.terms = 1;
          let newUser = user;
          sessionStorage.setItem("user", JSON.stringify(newUser));
          location.reload();
          this.errors = [];
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.terms-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #679e4e 0%, #679e4e 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.terms-wrapper {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

/* Header Section */
.terms-header {
  text-align: center;
  margin-bottom: 32px;
}

.terms-title {
  font-size: 32px;
  font-weight: 700;
  color: white;
  margin: 0 0 12px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.terms-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-weight: 400;
}

/* Content Card */
.terms-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.terms-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* Content Header */
.content-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f1f5f9;
}

.content-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 12px;
  color: white;
  font-size: 20px;
}

.content-title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

/* Terms Text */
.terms-text {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.text-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.item-bullet {
  width: 8px;
  height: 8px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-radius: 50%;
  margin-top: 8px;
  flex-shrink: 0;
}

.text-item p {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #475569;
}

/* Action Buttons */
.action-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.primary-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
  color: white;
  text-decoration: none;
}

.secondary-btn {
  background: white;
  color: #64748b;
  border-color: #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.secondary-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  color: #475569;
  text-decoration: none;
}

/* Agreement Section */
.agreement-section {
  margin: 16px 0;
}

.agreement-card {
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  transition: all 0.3s ease;
}

.agreement-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
}

.checkbox-wrapper {
  display: flex;
  align-items: flex-start;
}

.checkbox-label {
  font-size: 16px;
  line-height: 1.6;
  color: #374151;
  margin-left: 12px;
}

.terms-link {
  color: #3b82f6;
  font-weight: 600;
  text-decoration: none;
}

.terms-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

/* Custom Checkbox */
.custom-checkbox
  >>> .custom-control-input:checked
  ~ .custom-control-label::before {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  border-color: #3b82f6;
}

.custom-checkbox >>> .custom-control-label::before {
  border-radius: 6px;
  border: 2px solid #d1d5db;
  width: 24px;
  height: 24px;
}

.custom-checkbox >>> .custom-control-label::after {
  width: 24px;
  height: 24px;
}

/* Error Section */
.error-section {
  margin: -16px 0 0 0;
}

/* Save Section */
.save-section {
  display: flex;
  justify-content: center;
}

.save-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 16px 48px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
  min-width: 240px !important;
}

.save-btn:not(.btn-disabled):hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4) !important;
}

.btn-disabled {
  background: #9ca3af !important;
  box-shadow: none !important;
  cursor: not-allowed !important;
}

.save-icon {
  margin-right: 8px;
}

/* Footer */
.terms-footer {
  text-align: center;
  margin-top: 32px;
}

.footer-info {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .terms-container {
    padding: 16px;
  }

  .terms-card {
    padding: 24px;
  }

  .content-header {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .action-buttons {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .action-btn {
    padding: 14px 20px;
    font-size: 13px;
  }

  .terms-title {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .text-item {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }

  .item-bullet {
    margin-top: 0;
  }

  .save-btn {
    min-width: 100% !important;
    padding: 16px 24px !important;
  }

  .checkbox-label {
    font-size: 14px;
  }
}

/* Loading Animation */
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.save-btn[loading] {
  animation: pulse 1.5s ease-in-out infinite;
}
</style>